export const SERVICE_CATALOG = [
  {
    category: "Home Services",
    accent: "#10b981",
    services: [
      "Electricians",
      "Plumbers",
      "Carpenters",
      "Painters",
      "AC Repair",
      "Refrigerator Repair",
      "Washing Machine Repair",
      "Microwave Repair",
      "RO Water Purifier Service",
      "TV Repair",
      "Geyser Repair",
      "Chimney Repair",
      "CCTV Installation",
      "Door Lock Installation",
      "Pest Control",
      "Waterproofing",
      "Interior Designers",
      "Modular Kitchen Providers",
      "Furniture Assembly",
      "Sofa Repair",
      "Curtain Installation",
      "Tile Installation",
      "Marble Polish",
      "False Ceiling Contractors",
      "POP Contractors"
    ]
  },
  {
    category: "Cleaning Services",
    accent: "#0ea5e9",
    services: [
      "House Cleaning",
      "Deep Cleaning",
      "Bathroom Cleaning",
      "Kitchen Cleaning",
      "Sofa Cleaning",
      "Carpet Cleaning",
      "Water Tank Cleaning",
      "Office Cleaning",
      "Glass Cleaning",
      "Move-in/Move-out Cleaning"
    ]
  },
  {
    category: "Beauty & Wellness",
    accent: "#2563eb",
    services: [
      "Salon at Home",
      "Makeup Artists",
      "Bridal Makeup",
      "Hair Stylists",
      "Nail Artists",
      "Massage Therapists",
      "Spa Services",
      "Mehendi Artists",
      "Tattoo Artists",
      "Yoga Trainers",
      "Gym Trainers",
      "Nutritionists",
      "Dieticians"
    ]
  },
  {
    category: "Healthcare",
    accent: "#ef4444",
    services: [
      "Doctors",
      "Dentists",
      "Physiotherapists",
      "Nurses",
      "Caretakers",
      "Home ICU Services",
      "Ambulance Providers",
      "Diagnostic Labs",
      "Blood Collection",
      "Medical Equipment Rental",
      "Psychologists",
      "Counsellors"
    ]
  },
  {
    category: "Education",
    accent: "#7c3aed",
    services: [
      "Home Tutors",
      "Online Tutors",
      "Music Teachers",
      "Dance Teachers",
      "Art Teachers",
      "Language Trainers",
      "Coding Tutors",
      "Competitive Exam Coaching",
      "Career Counsellors"
    ]
  },
  {
    category: "Automobile",
    accent: "#f43f5e",
    services: [
      "Car Washing",
      "Car Detailing",
      "Bike Repair",
      "Car Repair",
      "Towing Services",
      "Tyre Services",
      "Puncture Repair",
      "Battery Replacement",
      "Car Accessories",
      "Vehicle Inspection",
      "Driving Schools"
    ]
  },
  {
    category: "Events",
    accent: "#f97316",
    services: [
      "Photographers",
      "Videographers",
      "Wedding Planners",
      "DJs",
      "Caterers",
      "Decorators",
      "Balloon Decoration",
      "Tent Houses",
      "Event Anchors",
      "Live Bands",
      "Magicians",
      "Pandits",
      "Priests",
      "Astrologers"
    ]
  },
  {
    category: "Business Services",
    accent: "#f59e0b",
    services: [
      "Chartered Accountants",
      "Company Secretaries",
      "GST Consultants",
      "Tax Consultants",
      "Auditors",
      "Lawyers",
      "Notaries",
      "Trademark Consultants",
      "ISO Consultants",
      "Digital Marketing Agencies",
      "SEO Experts",
      "Graphic Designers",
      "Video Editors",
      "Content Writers",
      "Web Developers",
      "App Developers",
      "Software Companies"
    ]
  },
  {
    category: "Construction",
    accent: "#ec4899",
    services: [
      "Architects",
      "Civil Contractors",
      "Building Contractors",
      "Mason Workers",
      "Fabricators",
      "Welders",
      "Borewell Contractors",
      "Solar Installers",
      "Elevator Installers",
      "Building Material Suppliers"
    ]
  },
  {
    category: "Packers & Movers",
    accent: "#14b8a6",
    services: [
      "Local Movers",
      "Interstate Movers",
      "Office Relocation",
      "Bike Transport",
      "Car Transport",
      "Warehousing",
      "Storage Services"
    ]
  },
  {
    category: "Travel",
    accent: "#3b82f6",
    services: [
      "Travel Agents",
      "Tour Operators",
      "Visa Consultants",
      "Passport Agents",
      "Taxi Operators",
      "Tempo Traveller Providers",
      "Bus Operators",
      "Car Rental Companies",
      "Bike Rental",
      "Hotel Owners",
      "Homestay Owners",
      "Resort Owners",
      "Tour Guides"
    ]
  },
  {
    category: "Financial Services",
    accent: "#0ea5e9",
    services: [
      "Insurance Agents",
      "Loan Agents",
      "Mutual Fund Advisors",
      "Stock Brokers",
      "Financial Advisors",
      "Investment Consultants"
    ]
  },
  {
    category: "Pets",
    accent: "#22c55e",
    services: [
      "Veterinarians",
      "Pet Groomers",
      "Pet Boarding",
      "Pet Walkers",
      "Dog Trainers",
      "Pet Sitters"
    ]
  },
  {
    category: "Religious Services",
    accent: "#8b5cf6",
    services: [
      "Pandits",
      "Maulvis",
      "Priests",
      "Granthis",
      "Temple Booking",
      "Religious Event Organizers"
    ]
  },
  {
    category: "Security",
    accent: "#06b6d4",
    services: [
      "Security Guards",
      "Bouncers",
      "CCTV Providers",
      "Fire Safety Consultants"
    ]
  },
  {
    category: "Laundry",
    accent: "#2563eb",
    services: [
      "Laundry Services",
      "Dry Cleaning",
      "Ironing Services"
    ]
  },
  {
    category: "Delivery & Logistics",
    accent: "#f97316",
    services: [
      "Bike Delivery Partners",
      "Courier Services",
      "Packers",
      "Truck Operators",
      "Freight Companies"
    ]
  },
  {
    category: "Rental Services",
    accent: "#0ea5e9",
    services: [
      "Furniture Rental",
      "Laptop Rental",
      "Camera Rental",
      "Sound System Rental",
      "Generator Rental",
      "Wedding Equipment Rental",
      "Costume Rental"
    ]
  },
  {
    category: "Digital Services",
    accent: "#6366f1",
    services: [
      "Freelancers",
      "UI/UX Designers",
      "AI Developers",
      "Data Analysts",
      "DevOps Engineers",
      "Cloud Consultants",
      "Cybersecurity Experts"
    ]
  },
  {
    category: "Agriculture",
    accent: "#22c55e",
    services: [
      "Tractor Rental",
      "Farm Equipment Rental",
      "Veterinary Services",
      "Dairy Consultants",
      "Irrigation Experts"
    ]
  },
  {
    category: "Miscellaneous",
    accent: "#f43f5e",
    services: [
      "Locksmiths",
      "Tailors",
      "Cobblers",
      "Gift Shops",
      "Florists",
      "Bakers",
      "Chefs",
      "Personal Shoppers",
      "Home Organizers",
      "Elder Care Services",
      "Child Care Providers",
      "Babysitter"
    ]
  }
];

export const flattenServices = (catalog) =>
  catalog.flatMap((section) =>
    section.services.map((service) => ({
      category: section.category,
      accent: section.accent,
      service
    }))
  );

export const filterCatalog = (catalog, term) => {
  const trimmed = (term || "").trim().toLowerCase();
  if (!trimmed) {
    return catalog;
  }

  return catalog
    .map((section) => {
      const categoryMatch = section.category.toLowerCase().includes(trimmed);
      const services = categoryMatch
        ? section.services
        : section.services.filter((item) => item.toLowerCase().includes(trimmed));

      return {
        ...section,
        services
      };
    })
    .filter((section) => section.services.length > 0);
};

export const slugify = (value) =>
  (value || "")
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const getCatalogByCategorySlug = (catalog, categorySlug) => {
  const target = (categorySlug || "").toLowerCase();
  return catalog.find((section) => slugify(section.category) === target) || null;
};

export const getCategoryTeaser = (section) => {
  const count = section?.services?.length || 0;
  return `Explore ${count} ${section.category.toLowerCase()} options with verified service providers and quick bookings.`;
};

export const getServiceBySlug = (catalog, categorySlug, serviceSlug) => {
  const category = getCatalogByCategorySlug(catalog, categorySlug);
  if (!category) {
    return null;
  }

  const service = category.services.find((item) => slugify(item) === (serviceSlug || "").toLowerCase());
  if (!service) {
    return null;
  }

  return { category: category.category, accent: category.accent, service, services: category.services };
};

export const getServiceDescription = (categoryName, serviceName) =>
  `Book verified ${serviceName.toLowerCase()} professionals under ${categoryName}. Compare providers, share your requirement once, and get contacted directly for scheduling and pricing.`;

export const isCabBookingService = (categoryName, serviceName) => {
  const category = (categoryName || "").toLowerCase();
  const service = (serviceName || "").toLowerCase();
  return category === "travel" && (service.includes("taxi") || service.includes("cab"));
};
